import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ACCOUNTS_MASTER_URL } from 'src/app/onelog/common/config/url';
import { RequestService } from 'src/app/onelog/services/request.service';
import {
  PAGE_SIZE,
  MAX_SIZE,
  CURRENCY_SYMBOL,
} from 'src/app/onelog/common/config/common';
import {
  SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS,
  SELECT_TYPE_DROP_DOWN_OPTIONS,
  DEFAULT_SELECTED_STATUS,
  DROP_DOWN_SETTING_BOOKTYPE,
  DEFAULT_SELECTED_STATUS_TITLE_MASTER,
  DROP_DOWN_LIST_PRODUCT_TYPE,
  DROP_DOWN_SETTING_PRODDUCT_TYPE,
  DROP_DOWN_LIST_BOOK_TYPE,
} from 'src/app/onelog/common/config/dropdown-config';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateSelectComponent } from 'src/app/onelog/common/fields/date-select/date-select.component';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';
import { DropDownComponent } from 'src/app/onelog/common/fields/drop-down/drop-down.component';

@Component({
  selector: 'app-accounts-master',
  templateUrl: './accounts-master.component.html',
  styleUrls: ['./accounts-master.component.css'],
})
export class AccountsMasterComponent {
  products: any = [];
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  selectedproductId: string = '';
  selectTypeDropDownOptions: any = SELECT_TYPE_DROP_DOWN_OPTIONS;
  publishedDateSelectedFilterData: any = [];
  selectStatusTypeDropDownOptions: any = SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS;
  selectedStatusFilterType: string = '';
  currencySymbol: any = CURRENCY_SYMBOL;
  selectedStatusType: any = [];
  selectedStatusFilter: any = [];
  selectedDefaultItemsStatus: any = [];
  selectedBookType: any = [];
  selectedProductType: any = [];
  dropdownListBookStatus: any = [];
  productStatusList: any = [];
  dropdownListProductType: any = [];
  dropdownSettingsProductType: IDropdownSettings = {};
  dropdownListBookType: any = [];
  dropdownSettingsBookType: IDropdownSettings = {};
  DefaultselectedOptionType: string = 'not in';
  ppdSelectedFilterData: any = [];
  contractedDateSelectedFilterData: any = [];
  defaultPublishedDateType: string = '';

  @ViewChildren(DateSelectComponent) NgbDate: QueryList<DateSelectComponent>;
  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent: QueryList<DropDownSingleSelectComponent>;
  @ViewChildren(DropDownComponent)
  DropDownComponents: QueryList<DropDownComponent>;

  constructor(
    private requestService: RequestService,
    private productStatus: ProductSatusService
  ) {}

  ngOnInit() {
    //this.getData(ACCOUNTS_MASTER_URL, this.createPostData());
    //this.getData(ACCOUNTS_MASTER_URL);

    this.dropdownSettingsBookType = DROP_DOWN_SETTING_BOOKTYPE;
    this.dropdownListProductType = DROP_DOWN_LIST_PRODUCT_TYPE;
    this.dropdownSettingsProductType = DROP_DOWN_SETTING_PRODDUCT_TYPE;
    this.dropdownSettingsBookType = DROP_DOWN_SETTING_BOOKTYPE;
    this.dropdownListBookType = DROP_DOWN_LIST_BOOK_TYPE;
    this.loadProductStatusList();

    this.publishedDateSelectedFilterData['date'] = '';
  }

  loadProductStatusList() {
    //this.showLoader = true;
    return this.productStatus.getStatusList().subscribe((data: {}) => {
      this.productStatusList = data;
      let statusList: any = [];
      let selectedStatusList: any = [];
      let defaultStatusList: any = DEFAULT_SELECTED_STATUS_TITLE_MASTER;
      let tempSelectedDd: any = [];
      this.productStatusList.data.forEach(function (
        currentValue: any,
        index: any,
        arr: any
      ) {
        let obj: any = {};
        obj['item_id'] = currentValue.attributes.name;
        obj['item_text'] = currentValue.attributes.name;
        statusList.push(obj);
        //statusList = '';
        console.log(currentValue);

        if (defaultStatusList.includes(currentValue.attributes.name)) {
          selectedStatusList.push(obj);
          tempSelectedDd.push(currentValue.attributes.name);
        }
      });
      console.log(selectedStatusList);
      this.dropdownListBookStatus = statusList;
      //this.showLoader = false;
      this.selectedDefaultItemsStatus = selectedStatusList;
      this.selectedStatusType = tempSelectedDd;

      this.getData(ACCOUNTS_MASTER_URL, this.createPostData());
      //this.showLoader = false;
    });
  }

  getData(
    url: string = ACCOUNTS_MASTER_URL,
    data: any = [],
    urlParams: string = ''
  ) {
    this.requestService
      .postRequest(url, data, urlParams)
      .subscribe((data: any) => {
        console.log(data);
        this.products = data.data;
        this.totalProducts = data.total;
        this.perPage = data.per_page;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
      });

    // this.requestService.getRequest(url).subscribe((data: any) => {
    //   console.log(data);
    //   this.products = data.data;
    //   this.totalProducts = data.total;
    //   this.perPage = data.per_page;
    //   this.lastPage = data.last_page;
    //   this.currentPage = data.current_page;
    // });
  }

  // createPostData() {
  //   return {
  //     selectedproductId: this.selectedproductId,
  //     selectedPublishedDate: Object.assign(
  //       {},
  //       this.publishedDateSelectedFilterData
  //     ),
  //   };
  // }

  createPostData() {
    this.setStatusFilterData();

    return {
      selectedBookType: this.selectedBookType,
      selectedProductType: this.selectedProductType,
      selectedproductId: this.selectedproductId,
      //selectedPPD: this.ppdSelectedFilterData,
      selectedPPD: Object.assign({}, this.ppdSelectedFilterData),
      selectedPublishedDate: Object.assign(
        {},
        this.publishedDateSelectedFilterData
      ),
      selectedContractedDate: Object.assign(
        {},
        this.contractedDateSelectedFilterData
      ),
      selectedStatus: Object.assign({}, this.selectedStatusFilter),
    };
  }

  updateSelectedType(event: any) {
    if (event.name == 'publishedDate') {
      this.publishedDateSelectedFilterData['selectedFilterType'] =
        event.selectedOption;
      //this.defaultPublishedDateType = event.selectedOption;
    }
    if (event.name == 'status') {
      this.selectedStatusFilterType = event.selectedOption;
    }
    if (event.name == 'contractedDate') {
      this.contractedDateSelectedFilterData['selectedFilterType'] =
        event.selectedOption;
    }
  }

  updateSelectedDate(event: any) {
    if (event.type == 'publishedDate') {
      this.publishedDateSelectedFilterData['date'] = event.dateString;
    }

    if (event.type == 'contractedDate') {
      this.contractedDateSelectedFilterData['date'] = event.dateString;
    }
  }

  search() {
    this.getData(ACCOUNTS_MASTER_URL, this.createPostData());
  }

  //Download Report
  downloadReport() {
    this.requestService.download(
      ACCOUNTS_MASTER_URL,
      this.createPostData(),
      '/?is_download=1',
      `FINANCE_ADVANCE_REPORT_${Date()}`
    );
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    console.log(eventData.currentPage);
    let urlParams = '?page=' + eventData.currentPage;
    this.getData(ACCOUNTS_MASTER_URL, this.createPostData(), urlParams);
  }

  setStatusFilterData() {
    if (
      this.selectedStatusFilterType !== null &&
      this.selectedStatusFilterType !== '' &&
      this.selectedStatusType.length > 0
    ) {
      this.selectedStatusFilter['selectedFilterType'] =
        this.selectedStatusFilterType;
      this.selectedStatusFilter['selected'] = this.selectedStatusType;
    } else {
      delete this.selectedStatusFilter['selectedFilterType'];
      delete this.selectedStatusFilter['selected'];
    }
    console.log(this.selectedStatusType.length);
  }

  updateSelectedDropDown(event: Event) {
    const data: any = event;
    if (data.type == 'productType') {
      if (data.action == 'selected') {
        this.selectedProductType.push(data.item.item_text);
      } else {
        const index = this.selectedProductType.indexOf(data.item.item_text);
        this.selectedProductType.splice(index, 1);
      }

      if (data.action == 'deSelectedAll') {
        this.selectedProductType = [];
      }
    }

    if (data.type == 'bookType') {
      if (data.action == 'selected') {
        this.selectedBookType.push(data.item.item_text);
      } else {
        const index = this.selectedBookType.indexOf(data.item.item_text);
        this.selectedBookType.splice(index, 1);
      }

      if (data.action == 'deSelectedAll') {
        this.selectedBookType = [];
      }
    }

    if (data.type == 'bookStatus') {
      if (data.action == 'selected') {
        this.selectedStatusType.push(data.item.item_text);
      } else {
        const index = this.selectedStatusType.indexOf(data.item.item_text);
        this.selectedStatusType.splice(index, 1);
      }

      if (data.action == 'deSelectedAll') {
        console.log('Deselected bookStatus');
        this.selectedStatusType = [];
      }
    }
  }

  clearFilters() {
    this.clearAllDates();
    this.clearAllDropDowns();
    this.clearAllMultiSelect();
  }

  clearAllDates(): void {
    this.NgbDate.forEach((datePickerComp) => {
      datePickerComp.clearDate();
    });
  }

  clearAllDropDowns() {
    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      DropDownComp.clearInput();
    });
  }

  clearAllMultiSelect() {
    this.DropDownComponents.forEach((DropDownComp) => {
      DropDownComp.clearAllSelection();
    });
  }

  resetDropDownVal(event: Event) {
    const e: any = event;
    if (e.name == 'publishedDate') {
      delete this.publishedDateSelectedFilterData['selectedFilterType'];
    }

    if (e.name == 'contractedDate') {
      delete this.contractedDateSelectedFilterData['selectedFilterType'];
    }

    if (e.name == 'status') {
      delete this.selectedStatusFilter['selectedFilterType'];
    }
  }

  //resetDateVal

  resetDateVal(event: Event) {
    const e: any = event;
    if (e.type == 'publishedDate') {
      delete this.publishedDateSelectedFilterData['date'];
    }

    if (e.type == 'contractedDate') {
      delete this.contractedDateSelectedFilterData['date'];
    }
  }
}
